<template>
  <div>
    <div
      class="podcast-thumbnail podcast-thumbnail__image"
      :class="{ 'podcast-thumbnail__image--active': active }"
      :style="style"
    >
      <template v-if="!hideOverlay">
        <div
          class="podcast-thumbnail__tag"
          :class="{ 'podcast-thumbnail__tag--active': active }"
        >
          <span v-if="active" class="podcast-thumbnail__title">
            <i class="fa fa-microphone-alt mr-2"></i
            >{{ $t('PODCASTS.LABELS.PUBLISHED') }}
          </span>
          <span v-else class="podcast-thumbnail__title">
            <i class="fa fa-pencil-alt mr-2"></i
            >{{ $t('PODCASTS.LABELS.DRAFT') }}
          </span>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PodcastThumbnail',
  props: {
    podcast: {
      type: Object,
      required: true,
    },
    hideOverlay: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    style() {
      if (this.podcast.thumbnail_photo) {
        const thumbnailUrl = this.podcast.thumbnail_photo.thumbnail;
        return {
          backgroundImage: 'url(' + thumbnailUrl + ')',
          backgroundSize: 'cover',
        };
      }
      if (this.podcast.cover_photo) {
        const thumbnailUrl = this.podcast.cover_photo.thumbnail;
        return {
          backgroundImage: 'url(' + thumbnailUrl + ')',
          backgroundSize: 'cover',
        };
      }
      return {};
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';
$tag-height: 26px;

.podcast-thumbnail {
  &__title {
    font-size: 16px;
    font-weight: 300;
  }
  &__tag {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: $border-radius 0 $border-radius 0;
    color: $white;
    height: $tag-height;
    padding: 2px 9px;
    font-size: 0.75rem;
    top: 0;
    left: 0;
    font-weight: 500;
    background-color: $medium-gray;

    &--active {
      background-color: var(--brand-color, $coral);
    }
  }
  &__image {
    position: relative;
    border-radius: $border-radius;
    background-position: center center;
    background-size: auto 65%;
    background-repeat: no-repeat;
    background-color: var(
      --brand-color-with-opacity-03,
      rgba($light-bubblegum, 0.3)
    );
    object-fit: cover;
    transition: all 0.3s ease-in-out;
    height: 100%;

    &--active {
      background-color: $light-gray;
    }
  }
}
</style>
